import { ComponentType } from 'react';

import { CompanyCard, SoldToAddressCard } from '../../../../../../components/cards/company';
import { AdditionalAttachmentCard } from '../../../../../../components/cards/financial/AttachmentCard';
import PrivacyPolicyCard from '../../../../../../components/cards/financial/PrivacyPolicyCard';
import CompanyPage from '../../../../../../features/CompanyPage';
import ReviewPage from '../../../../../../features/ReviewPage';
import { CARD_CATEGORIES } from '../../../../../../shared/cardConfig/constants';
import {
  ATTACHMENT_FIELDS,
  COMPANY_FIELDS,
  SOLD_TO_ADDRESS_FIELDS
} from '../../../../../../shared/fieldConfig/constants';
import { PAGE_ROUTES } from '../../../../../../utils/constants';

// ----------------- Type Definitions -----------------
interface Field {
  key: string;
  required?: boolean;
}

interface Card {
  key: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Component: ComponentType<any>;
  fields?: Field[];
  hideSameAs?: boolean;
  fieldWrapper?: string;
  errorMustContain?: string;
}

interface Page {
  route: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Component: ComponentType<any>;
  cards?: Card[];
  accordions?: { title: string; cards: Card[] }[];
}

// ----------------- Page Templates -----------------
const companyPageTemplate: Page = {
  route: PAGE_ROUTES.company,
  Component: CompanyPage,
  cards: [
    {
      key: CARD_CATEGORIES.company,
      Component: CompanyCard,
      fields: [
        { key: COMPANY_FIELDS.legalName },
        { key: COMPANY_FIELDS.tradeDbaName, required: true }
      ]
    },
    {
      key: CARD_CATEGORIES.soldTo,
      Component: SoldToAddressCard,
      fields: [
        { key: SOLD_TO_ADDRESS_FIELDS.address },
        { key: SOLD_TO_ADDRESS_FIELDS.taxNumber1, required: true },
        { key: SOLD_TO_ADDRESS_FIELDS.taxNumber2 },
        { key: SOLD_TO_ADDRESS_FIELDS.email },
        { key: SOLD_TO_ADDRESS_FIELDS.telephone1 },
        { key: SOLD_TO_ADDRESS_FIELDS.telephone2 }
      ],
      errorMustContain: 'address'
    },
    {
      key: CARD_CATEGORIES.additionalAttachmentCard,
      Component: AdditionalAttachmentCard,
      fields: [{ key: ATTACHMENT_FIELDS.additionalAttachment }]
    },
    {
      key: CARD_CATEGORIES.privacyPolicy,
      Component: PrivacyPolicyCard
    }
  ]
};

const reviewPageTemplate: Page = {
  route: PAGE_ROUTES.review,
  Component: ReviewPage,
  accordions: [
    {
      title: 'tabTitles.company',
      cards: companyPageTemplate.cards!
    }
  ]
};

const pages: Page[] = [companyPageTemplate, reviewPageTemplate];

export default pages;